import _ from 'lodash';
import moment from 'moment';
import { removeDuplicates } from '../utils/helper';

export const Operators = {
  GreaterThan: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a > b;
    let message = () => { };
    if (result === false) {
      message = message = (a, b) => {
        return a + ' should be Greater than ' + b;
      };
    }
    return { result, message };
  },
  LessThan: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a < b;
    let message = () => { };
    if (result === false) {
      message = message = message = (a, b) => {
        return a + ' should be Less than ' + b;
      };
    }
    return { result, message };
  },
  PayCycleStart: (a, b) => {
    let result = true;
    let message = () => { };

    if (a && a !== 0) {
      a = new Date(a);
      if (a.getDate() === 1 || a.getDate() === 16) {
        result = true;
      } else {
        result = false;
      }
      if (result === false) {
        message = (a, b) => {
          return a + ' should be Pay Cycle start date 1 or 16';
        };
      }
    }
    return { result, message };
  },
  PayCycleEnd: (a, b) => {
    let result = true;
    let message = () => { };

    if (a && a !== 0) {
      a = new Date(a);
      b = parseInt(moment(a).endOf('month').format('DD'));
      if (a.getDate() === 15 || a.getDate() === b) {
        result = true;
      } else {
        result = false;
      }
      if (result === false) {
        message = (a, b) => {
          return a + ' should be Pay Cycle End date 15 or end date of selected Month';
        };
      }
    }
    return { result, message };
  },
  LessThanOrNull: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = b !== '' && b !== null && b !== undefined && b !== 0 ? a < b : true;
    let message = () => { };
    if (result === false) {
      message = message = message = (a, b) => {
        return a + ' should be Less than ' + b;
      };
    }
    return { result, message };
  },
  EqualsTo: (a, b) => {
    a = isNaN(a) ? a : (isNaN(parseFloat(a)) ? a : parseFloat(a));
    b = isNaN(b) ? b : (isNaN(parseFloat(b)) ? b : parseFloat(b));
    let result = true;
    if (isNaN(a) && isNaN(a) && a?.length === b?.length) {
      a = (a || '').split('|');
      b = (b || '').split('|');
      if (a.length === b.length) {
        a.forEach(x => {
          if (b.find(y => y === x) === undefined) {
            result = false;
          }
        });
      } else {
        result = false;
      }
    } else {
      result = a === b;
    }

    let message = () => { };
    if (result === false) {
      message = message = message = (a, b) => {
        return a + ' should be Equal to ' + b;
      };
    }
    return { result, message };
  },
  LessThanEqualsTo: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    let result = a <= b;
    if (a === -1) {
      result = false;
    }
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Less than or equal to ${b}`;
      };
    }
    return { result, message };
  },
  Like: (a, b) => {
    const result = a.indexOf(b) !== -1;
    let message = () => { };
    if (result === false) {
      message = message = message = (a, b) => {
        return a + ' not contain ' + b;
      };
    }
    return { result, message };
  },
  Contains: (a, b) => {
    let result = false;
    let message = () => { };
    if (typeof b === typeof a) {
      result = b.includes(a);
    }
    if (result === false) {
      message = message = message = (a, b) => {
        return a + ' not contain ' + b;
      };
    }
    return { result, message };
  },
  GreaterThanEqualsTo: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a >= b;
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Greater than or equal to ${b}`;
      };
    }
    return { result, message };
  },
  NotEquals: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a !== b;
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Not equals to ##fieldNameB## ${b}`;
      };
    }
    return { result, message };
  },
  NotIn: (a, b = []) => {
    const result = (((Array.isArray(b)
      ? b
      : typeof b === 'string'
        ? (b || '').split('|')
        : []) || []).find(x => x === a ||
          (a?.split('|') || []).find(t => t === x)) === undefined);
    let message = () => { };
    if (result === false) {
      message = '##fieldNameB## should not contain value ' + a;
    }
    return { result, message };
  },
  In: (a, b = []) => {
    const result = (((Array.isArray(b)
      ? b
      : typeof b === 'string'
        ? (b || '').split('|')
        : []) || []).find(x => x === a ||
          (a?.split('|') || []).find(t => t === x)) !== undefined);
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return a + ' should exist in ##fieldNameB## ';
      };
    }
    return { result, message };
  },
  Between: (a, b = []) => {
    const result = (a > b[0] && a < b[1]);
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return a + ' should be between ##fieldNameB## ';
      };
    }
    return { result, message };
  },
  BetweenInclusive: (a, b = []) => {
    const result = (a >= b[0] && a <= b[1]);
    let message = () => { };
    if (result === false) {
      message = (a, b) => {
        return a + ' should be between  ##fieldNameB## ';
      };
    }
    return { result, message };
  }
};

export const DataFormat = {
  DateTime: 'DateTime',
  Text: 'Text',
  Decimal: 'Decimal',
  Money: 'MoneyNumber',
  MoneyDecimal: 'MoneyDecimal',
  Percent: 'Percent',
  PercentDecimal: 'DecimalPercent'
};

export const AdvanceFilterOperators = [
  // {
  //   operator: undefined,
  //   Name: 'None'
  // },
  // {
  //   operator: Operators.GreaterThan,
  //   Name: 'GreaterThan'
  // },
  // {
  //   operator: Operators.LessThan,
  //   Name: 'LessThan'
  // },
  {
    operator: Operators.EqualsTo,
    Name: 'Display Only Selected'
  },
  // {
  //   operator: Operators.NotEquals,
  //   Name: 'NotEquals'
  // },
  // {
  //   operator: Operators.GreaterThanEqualsTo,
  //   Name: 'GreaterThanEqualsTo'
  // },
  // {
  //   operator: Operators.LessThanEqualsTo,
  //   Name: 'LessThanEqualsTo'
  // },
  {
    operator: Operators.In,
    Name: 'Display Combinations'
  }//,
  // {
  //   operator: Operators.NotIn,
  //   Name: 'NotIn'
  // }
  // {
  //   operator: Operators.Like,
  //   Name:'Like'
  // },
  // {
  //   operator: Operators.Between,
  //   Name:'Between'
  // }

];

export const DataOperators = {
  Count: (data, key) => {
    return ((data || []).map((x) => x[key]))?.length || 0;
  },
  DistinctCount: (data, key) => {
    const res = removeDuplicates(((data || []).map((x) => x[key])) || []);
    return res.length;
  },
  Sum: (data, key) => {
    const res = _.sumBy(data || [], function (el) {
      return el[key] || 0;
    });
    return res;
  },
  Average: (data, key) => {
    if (data === undefined || data.length <= 0) {
      return 0;
    }
    const res = DataOperators.Sum(data, key);
    return res / data.length;
  },
  SumDividedBy100: (data, key) => {
    const res = _.sumBy(data || [], function (el) {
      return el[key] || 0;
    });
    return res / 100;
  }
};

export const marketRequiredField = ['marketName',
  'preferredName',
  'departmentName',
  'allocationStartDate',
  'allocationEndDate',
  'marketBillingPercent',
  'marketAllocationPercent',
  'division'
];

export const propertyRequiredField = ['marketName',
  'preferredName',
  'departmentName',
  'allocationStartDate',
  'allocationEndDate',
  'billingStartDate',
  'billingEndDate',
  // 'marketBillingPercent',
  // 'marketAllocationPercent',
  'propertyName',
  'legalEntity',
  'propertyBillingPercent',
  'additionalFixedAmount',
  'flatrateType',
  'propertyAllocationPercent',
  'pmaTitle'
];
export const DateFormat = 'YYYY/MM/DD';// 'YYYY-MM-DD';
export const DateFormatMMDDYYYY = 'MM/DD/YYYY';

export const propertyDisabledField = [
  'isAllocatedToLegalEntity',
  'propertyName',
  'legalEntity'
];

export const ServiceTypes = {
  Property_Management: 1,
  Leasing: 2,
  Property_Accounting: 3,
  Engineering: 4,
  Development: 5,
  Construction: 6,
  Corporate_Services: 7,
  Capital_Markets: 8,
  Program_Management: 9
};

export const Markets = {
  SRP: 22
};

export const SECTIONS = {

  ALLOCATIONS: 8,
  MARKET_ALLOCATION: 9,
  PROPERTY_ALLOCATION: 10,

  PROPERTIES: 18,

  PROPERTY_TRANSITION: 14,
  TRANSITION_DETAIL: 26,
  ASSIGNMENT_DETAIL: 19,
  CLIENTS: 20,
  CUSTOMER_DETAIL: 27,
  PROPERTY_MANAGEMENT_FEES: 37,

  MARKET_REIMBURSEMENT_VARIANCE_ANALYSIS: 35,
  PROPERTY_REIMBURSEMENT_VARIANCE_ANALYSIS: 50,
  PROPERTY_LEVEL: 23,
  CATEGORY_LEVEL: 24,

  CONFIGURATION: 6,
  CONFIGURE_SERVICE_TYPE_NOTIFICATION: 30,
  CONFIGURE_SERVICE_TYPE_DEPARTMENT: 28,
  CONFIGURE_BURDEN_RATE: 33,
  CONFIGURE_DESIGNATION_THRESHOLD_VARIANCE: 32,
  CONFIGURE_WIDGET: 48,
  CONFIGURE_GROUP_WIDGET: 15,
  CONFIGURE_GROUP_ACCESS_PERMISSION: 25,
  CONFIGURE_USER_MARKET_PERMISSION: 38,
  CONFIGURE_SERVICE_TYPE_PAYCODE: 46,
  CONFIGURE_PROPERTY_ACCOUNTING_PAYROLL: 47,
  CONFIGURE_EXPENSE_GROUP_PAYCODE: 94,
  CONFIGURE_EMPLOYEE_TITLE: 34,
  CONFIGURE_CONTACT_ROLES: 95,
  REFRESH_CACHE: 96,
  // CONFIGURE_OVERTIME_TIMESHEET: 95,

  DATA_CENTER_CONFIGURATION: 58,
  CONFIGURE_SDC_LEADERSHIP_EMPLOYEE: 59,
  CONFIGURE_SDC_DESIGNATION_PMA_TITLE: 60,
  CONFIGURE_SDC_PAYROLL_INFO: 61,
  CONFIGURE_SDC_PROPERTY_SPLIT: 63,
  CONFIGURE_SDC_EMPLOYEE_BONUS_PERCENT: 66,

  YEAR_END_BONUS: 68,
  CONFIGURE_YEARLY_BONUS_TITLE: 69,

  EMPLOYEE_YEARLY_BONUS: 70,
  YEARLY_BONUS_ACCRUAL: 71,
  YEAR_END_COMPLIANCE: 73,
  YEAR_END_BONUS_REPORT: 74,
  CENTERALIZED_AR_ADMIN_PROPERTY_MAPPING: 75,
  CENTERALIZED_AR_PROPERTY_TENANT_MAPPING: 76,
  CENTERALIZED_AR_PAYROLL_CONFIGURATIONS: 77,
  CENTERALIZED_AR_REIMBURSEMENT_REPORT: 78,

  UNMAPPED_REPORT: 80,

  REPORTS: 21,
  ABOUT_US: 7,

  DASHBOARD: 5,
  PENDING_ACTION: 3,

  EMPLOYEES: 2,
  MARKETS: 22,
  ASSIGNMENTS: 11,

  OVERTIMEATTANDENCESHEET: 53,

  ALLOCATION_COMPLIANCE: 57,

  ALL_ACCESS_MARKET: 1,
  SENSITIVE_DATA_ACCESS: 2,
  Property_Reimbursement_Report: 39,
  Market_Reimbursement_Report: 40,
  Employee_New_Hire_Report: 41,
  Employee_Termination_Report: 42,
  Employee_Allocation_Change_by_Market_Report: 43,
  Employee_Allocation_Change_by_Property_Report: 44,
  Employee_Reimbursements_Billed_Amount: 55,
  Property_Variance_Detail_Report: 62,
  Property_Allocation_Summary: 52,
  Market_Allocation_Summary: 64,
  Datacenter_Invoice_Report: 65,
  Datacenter_Property_Reimbursement_Report: 67,
  Datacenter_Property_Variance_Detail_Report: 87,
  Market_Variance_Detail_Report: 88,
  Year_End_Bonus_Market_Reimbursement_Report: 91,
  PTF_DETAIL_REPORT: 92,
  ADD_EDIT: 'Add OR Edit',
  VIEW: 'View'
};

export let SPSToken = '';
export let SPSDrive = null;
export let lastFetched = null;
export let tokenLastFetch = null;

export const setSPSToken = token => {
  SPSToken = token;
  lastFetched = new Date();
};

export const getSPSTokenData = token => {
  return SPSToken;
};
export const getLastFetchedSPSTokenData = token => {
  return lastFetched;
};
export const getTokenLastFetchedData = token => {
  return tokenLastFetch;
};

export const setLastTokenFetched = token => {
  tokenLastFetch = new Date();
};

export const setSPSDrive = driveList => {
  SPSDrive = driveList;
};

export const DOWNLOAD_STATUS = {
  inProgress: 'progress',
  downloading: 'downloading',
  completed: 'completed',
  failed: 'failed',
  uploading: 'uploading',
  uploaded: 'uploaded',
  processing: 'processing'
};

export const TRANSITION_TYPE_ID = {
  NEW_ASSIGNMENT: '1',
  CHANGE_IN_OWNERSHIP: '2',
  TERMINATION: '3'
};

export const DEPARTMENT = {
  MANAGEMENT_SERVICE: 9,
  PROPERTY_ACCOUNTING: 16,
  CENTRALIZED_AR: 30
};

export const TERMINATION_TYPE = {
  BY_SERVICE: 'By Service',
  BY_PROPERTY: 'By Property'
};

export const SOURCE_ACCOUNTING_TYPE = {
  STREAM_ACCOUNTING_SYSTEM: 1,
  CLIENT_ACCOUNTING_SYSTEM: 2
}

export const RECORD_SOURCE = {
  GRACE_PERIOD: 51
};

export const EXCEL_FILE = '../public/files/Employee Bonus by Title Template.xlsx';
export const OT_TIMESHEET_FILE = '../public/files/OT Timesheet Template.xlsx';
export const DOWNLOAD_DATA_MESSAGE = 'Report will be downloaded into the excel file. Please check the downloaded file.';
